import { createFeatureSelector, createSelector } from "@ngrx/store";

const selectCareerGoalState = createFeatureSelector<string>('careerGoal');
export const selectCareerGoal = createSelector(
  selectCareerGoalState,
  (state: string) => state
)